import styles from "./tag.module.css";

interface Props {
    icon: JSX.Element;
    text: string;
}

export default function Tag({ icon, text }: Props) {
    return (
        <div className={styles.container}>
            {icon}
            <p>{text}</p>
        </div>
    );
}